import axios from "axios"

export const AuthService = () =>
    axios.create({
        baseURL: '/api/auth',
        timeout: 15000,
    });